<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-list dense>
        <v-list-item link @click="push('summary')">
          <v-list-item-action>
            <v-icon>mdi-chart-pie</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>利用状況</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('predictions')">
          <v-list-item-action>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>開催前の予想</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('open_predictions')">
          <v-list-item-action>
            <v-icon>mdi-calendar-alert</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>開催中の予想（通報用）</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('comments')">
          <v-list-item-action>
            <v-icon>mdi-comment</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>コメント</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('reply')">
          <v-list-item-action>
            <v-icon>mdi-comment-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>返信</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('create_predictions')">
          <v-list-item-action>
            <v-icon>mdi-file-document-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>予想問題作成</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('generate_predictions')">
          <v-list-item-action>
            <v-icon>mdi-file-document-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>予想問題自動生成</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('ranking')">
          <v-list-item-action>
            <v-icon>mdi-trophy</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>イベントランキング</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('event_predictions')">
          <v-list-item-action>
            <v-icon>mdi-calendar-badge</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>イベント参加中の予想</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('bot_management')">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>ボット管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('users')">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>ユーザー情報</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="push('crumbs')">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>調査ログ</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="indigo"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>神様のサイコロ管理画面</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-container
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col>
            <router-view :key="$route.fullPath"/>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
    }),
    methods: {
      push (name) {
        this.$router.push({name: name})
      }
    }
  }
</script>